<template>
  <simple-modal @rejected="$emit('rejected')">
    <section class="flex justify-center items-center">
      <div class="ml-5 mr-5 chevron-wrapper">
        <fai
          class="chevron"
          :class="showLeftChevron ? 'text-blue' : 'text-gray-400'"
          :icon="['far', 'chevron-left']"
          @click="showLeftChevron ? $emit('changeIndex', -1) : null"
        />
      </div>
      <div v-if="mediaUrl" class="media-index-wrapper relative w-10/12">
        <div v-if="indexInfo && indexInfo[1] != 0" class="index-number">{{indexInfo[0]+1}}/{{indexInfo[1]+1}}</div>
        <img
          v-if="mediaType.includes('image')"
          class="media-container image-media rounded-md"
          :src="mediaUrl"
        >
        <VideoPlayer
          v-else-if="mediaType.includes('video')"
          class="media-container video-media"
          ref="video-player"
          :src="mediaUrl"
        />
        <iframe
          v-else
          class="media-container yt-media"
          :src="mediaUrl"
        />
      </div>
      <div class="ml-5 mr-5 chevron-wrapper">
        <fai
          class="chevron"
          :class="showRightChevron ? 'text-blue' : 'text-gray-400'"
          :icon="['far', 'chevron-right']"
          @click="showRightChevron ? $emit('changeIndex', 1) : null"
        />
      </div>
    </section>

    <div slot="buttons"/>
  </simple-modal>
</template>

<script>
import { SimpleModal } from '@springbig/sb-components'
import VideoPlayer from './video-player'


export default {
  props: {
    mediaUrl: {type: String, required: true},
    mediaType: String, // "image", "video", "youtube"
    indexInfo: Array // [current index, last index]
  },

  name: 'MediaPreviewModal',

  components: {
    SimpleModal,
    VideoPlayer
  },

  computed: {
    showRightChevron() {
      return this.indexInfo[0] < this.indexInfo[1]
    },

    showLeftChevron() {
      return this.indexInfo[0] > 0
    },
  },
}
</script>

<style scoped>
.simple-modal >>> section.content {
  min-width: 0;
}

.simple-modal >>> .svg-inline--fa.chevron {
  transform: scale(4,6);
}

.simple-modal >>> #video_player {
  max-height: 500px;
}

.simple-modal >>> .error-banner {
  display: none;
}

.simple-modal >>> .yt-media {
  min-width: 640px;
  min-height: 385px;
}

.simple-modal >>> .index-number {
  position: absolute;
  right: 10px;
  top: 10px;
  color: white;
  background-color: rgba(0,0,0, 0.5);
  border-radius: 6px;
  padding: 2px 10px;
  z-index: 1;
}

.simple-modal >>> .chevron-wrapper {
  padding: 10px;
}
</style>
